exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__price___2L6bk{font-size:30px;font-weight:300;letter-spacing:.6px;text-align:right;color:#333;margin-top:10px}", ""]);

// exports
exports.locals = {
	"price": "style__price___2L6bk"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/summary-diamond/style.css
// module id = 718
// module chunks = 0